import { Link, useLocation } from "react-router-dom";
import { FaHome, FaGift, FaShareAlt, FaTrophy, FaCrown } from "react-icons/fa";
import { isEmpty } from "lodash";
import { useContextSelector } from "use-context-selector";
import AuthContext from "../context/AuthContext";

export default function MobileAppNavigation() {
  const { pathname, search } = useLocation();
  const user = useContextSelector(AuthContext, ctx => ctx.user);
  const setLoginModal = useContextSelector(AuthContext, ctx => ctx.setLoginModal);
  const tab = new URLSearchParams(search).get("tab");
  const inviteActive = pathname === "/member/inviteFriends" || (pathname === "/member" && tab === "invite");
  const rewardActive = pathname === "/member/rewardCenter" || (pathname === "/member" && tab === "rewardCenter");
  const memberActive = pathname.startsWith("/member") && !inviteActive && !rewardActive;
  const requireLogin = event => {
    if (isEmpty(user)) {
      event.preventDefault();
      setLoginModal(true);
    }
  };
  const items = [
    { label: "Home", path: "/", Icon: FaHome, active: pathname === "/" },
    { label: "Promotion", path: "/promotions", Icon: FaGift, active: pathname.startsWith("/promotions") || pathname === "/promotion" },
    { label: "Invite", path: "/member?tab=invite", Icon: FaShareAlt, active: inviteActive, invite: true, requiresLogin: true },
    { label: "Reward", path: "/member?tab=rewardCenter", Icon: FaTrophy, active: rewardActive, requiresLogin: true },
    { label: "Member", path: "/member", Icon: FaCrown, active: memberActive },
  ];

  return (
    <nav className="mobile-app-navigation" aria-label="Mobile navigation">
      <svg className="mobile-navigation-gradients" aria-hidden="true" width="0" height="0">
        <defs>
          <linearGradient id="mobile-navigation-gold" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor="#fff3a0" />
            <stop offset="55%" stopColor="#ffdc68" />
            <stop offset="100%" stopColor="#eeb441" />
          </linearGradient>
        </defs>
      </svg>
      {items.map(({ label, path, Icon, active, invite, requiresLogin }) => (
        <Link key={label} to={path} className={`${invite ? "mobile-app-navigation-invite" : ""}${active ? " active" : ""}`.trim()} aria-current={active ? "page" : undefined} onClick={requiresLogin ? requireLogin : undefined}>
          {invite ? (
            <span className="mobile-app-navigation-invite-bubble">
              <Icon aria-hidden="true" />
              <span>{label}</span>
            </span>
          ) : (
            <>
              <Icon className="mobile-navigation-icon" aria-hidden="true" />
              <span>{label}</span>
            </>
          )}
        </Link>
      ))}
    </nav>
  );
}
